export enum SocialShareType {
  Facebook = 'Facebook',
  FacebookMessenger = 'Facebook Messenger',
  LinkedIn = 'LinkedIn',
  X = 'X',
  Email = 'Email',
  Instagram = 'Instagram',
}

export interface SocialShareData {
  url: string
  text?: string
  hashtags?: string
  instagramLink?: string
}
